import { render } from "./MailFilter.vue?vue&type=template&id=32c31deb&scoped=true"
import script from "./MailFilter.vue?vue&type=script&lang=js"
export * from "./MailFilter.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./MailFilter.vue?vue&type=style&index=1&id=32c31deb&scoped=true&lang=css"

import exportComponent from "/home/projects/frontend.vendor-mailing-system.pravin/vendor-mailig-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32c31deb"]])

export default __exports__